class Corporate {
	constructor(config) {
		this.config = Object.assign({
			scope: '[data-corporate="scope"]',
			radio: '[data-corporate="radio"]',
			toggle: '[data-corporate="toggle"]',
		}, config);

		this.init();
	}

	init() {
		$(this.config.scope).each((index, element) => {
			this.toggle($(element));
		});

		$(document).off('.corporate').on('change.corporate', `${this.config.scope} ${this.config.radio}`, (event) => {
			let $scope = $(event.currentTarget).closest(this.config.scope);
			this.toggle($scope);
		});
	}

	toggle($scope) {
		let $checked = $scope.find(`${this.config.radio}:checked`);

		if($checked.length < 1 || $checked.val() == 0) {
			this.close($scope);
		} else {
			this.open($scope);
		}
	}

	open($scope) {
		let $toggle = $scope.find(this.config.toggle);
		$toggle.slideDown();
		$toggle.attr('disabled', false);
	}

	close($scope) {
		let $toggle = $scope.find(this.config.toggle);
		$toggle.slideUp();
		$toggle.attr('disabled', true);
	}
}

export default new Corporate;